export default __webpack_public_path__ + "static/media/home-new-active.5d50faa9.svg";